import { Component, inject, OnInit } from '@angular/core';
import { COMPONENT_VERSIONS } from '@fgb/core';
import { MarketplacePageV1Component } from './marketplace-page-v1/marketplace-page-v1.component';
import { MarketplacePageV2Component } from './marketplace-page-v2/marketplace-page-v2.component';

const componentMap = {
  1: MarketplacePageV1Component,
  2: MarketplacePageV2Component,
};

type MarketplaceComponentVersion = keyof typeof componentMap;

/** Container component that delegates rendering to a versioned marketplace component based on COMPONENT_VERSIONS config. */
@Component({
  selector: 'fgb-marketplace-page',
  template: `<ng-container *ngComponentOutlet="component"></ng-container>`,
})
export class MarketplacePageComponent implements OnInit {
  private readonly marketplaceVersion = inject(COMPONENT_VERSIONS)?.marketplace as MarketplaceComponentVersion;

  ngOnInit() {
    console.log(`Marketplace component version: ${this.marketplaceVersion}`);
  }

  get component() {
    return componentMap[this.marketplaceVersion || 1]; // default to version 1 if not specified
  }
}
